<template>
  <div
    class="cursor-pointer hover:bg-slate-100 h-full aspect-square grid place-items-center"
    title="Comparison basket"
    @click="$emit('toggle-basket')"
  >
    <div
      class="aspect-square cursor-pointer relative h-full w-full flex items-center justify-center"
    >
      <Transition
        name="fade"
        mode="out-in"
      >
        <div
          v-if="!isActive"
          key="other"
          class="aspect-square h-full w-full flex items-center justify-center absolute inset-0"
          style="--fa-counter-background-color: var(--color-green-600)"
        >
          <Icon :icon="faBasketShopping" />
          <div
            class="absolute right-2 top-2 bg-green-600 text-white rounded-full w-4 h-4 leading-[4] flex items-center justify-center text-xs font-semibold overflow-hidden text-center"
          >
            <span class="text-center w-2">
              {{ basketCount }}
            </span>
          </div>
          <!-- </div> -->
        </div>
        <div
          v-else
          key="thing"
          class="aspect-square h-full w-full flex items-center justify-center absolute inset-0"
        >
          <div class="fa-stack fa-fw">
            <Icon :icon="faXmark" />
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script lang="ts" setup>
// import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useBasketStore } from '@/store/modules/basket.ts'
// Store actions
// import { mapActions } from 'vuex'
import { Icon } from '@repo/ui'
import { faBasketShopping } from '@repo/icons/light/faBasketShopping'
import { faXmark } from '@repo/icons/light/faXmark'

defineProps(['deviceNavOpen', 'isActive'])

const basketStore = useBasketStore()
const { basketCount } = storeToRefs(basketStore)
// const { closeBasket, clearBasket, openBasket, removeFromBasket } = basketStore

// const basket = computed(() => getBasket)
// // const basketCount = computed(() => {
// //   return basketStore.basketCount
// // })
// const itemsInBasket = computed(() => {
//   return basketCount.value > 0
// })

// function remove(id: string) {
//   removeFromBasket(id)
// }

// function quoteComparison() {
//   // TODO: Add modal
//   closeBasket()
// }

// function clearBasketCloseMenu() {
//   clearBasket()
//   closeBasket()
// }
</script>
